import React, { useEffect, useState } from 'react';
import { FormTab } from 'react-admin';

/**
 * FormTab that delays mounting until first visit, then keeps children mounted.
 *
 * Unmounting on every hide wiped ArrayInput values (tickets/coupons) when using
 * Next/Back — remount re-applied defaultValue={[]}. Keeping visited tabs mounted
 * preserves form data; FormTab still hides inactive panels with CSS.
 *
 * Inactive tabs stay out of the first paint so heavy tabs don't lag keystrokes
 * until the user actually opens them.
 */
export const LazyFormTab = (props) => {
  const { children, hidden, intent, ...rest } = props;
  const [visited, setVisited] = useState(() => !hidden);

  useEffect(() => {
    if (!hidden) {
      setVisited(true);
    }
  }, [hidden]);

  if (intent === 'header') {
    return <FormTab {...props} />;
  }

  return (
    <FormTab {...rest} intent={intent} hidden={hidden}>
      {visited ? children : null}
    </FormTab>
  );
};

LazyFormTab.displayName = 'FormTab';
